export interface UserFull {
  id: number;
  login: string;

  display_name: string;
  github_user: string | null;
  slack_id: string | null;

  fulltime: boolean;
  start_date: Date | null;
  availability: number;
  pto: number;
}

export function UserFullFromJSON(json: any): UserFull {
  return {
    id: json.id,
    login: json.login,

    display_name: json.display_name ?? "",
    github_user: json.github_user ?? null,
    slack_id: json.slack_id ?? null,

    fulltime: Boolean(json.fulltime),
    start_date: json.start_date ? new Date(json.start_date) : null,
    availability: json.availability ?? 0,
    pto: json.pto ?? 0,
  };
}
